import { Button } from '@/components/core/Button';
import {
    Dialog,
    DialogBody,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogHeaderDefault,
} from '@/components/core/Dialog';
import { useToast } from '@/hooks/useToast';
import { useTranslation } from '@/hooks/useTranslation';

import { EmailInvitationRecord } from './invitation';
import { useDeleteEmailInvitation } from './invitation.queries';

interface DeleteInvitationDialogProps {
    invitation?: EmailInvitationRecord;
    open: boolean;
    onClose: () => void;
}

const DeleteInvitationDialog = ({ invitation, open, onClose }: DeleteInvitationDialogProps) => {
    const { t } = useTranslation();
    const { toast } = useToast();
    const deleteInvitation = useDeleteEmailInvitation();

    const confirm = () => {
        if (invitation?.id == null) {
            return;
        }
        deleteInvitation.mutate(invitation.id, {
            onSuccess: () => {
                toast.success('INVITATION_DELETED');
                onClose();
            },
            onError: () => {
                toast.error('SAVE_ERROR_MESSAGE');
            },
        });
    };

    return (
        <Dialog open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
            <DialogContent variant="small">
                <DialogHeader>
                    <DialogHeaderDefault closeLabel={t('CLOSE')}>
                        {t('INVITATION.DELETE_INVITATION.LABEL')}
                    </DialogHeaderDefault>
                </DialogHeader>
                <DialogBody>
                    <p className="tw-text-t-sm tw-text-t-primary lg:tw-text-t-base">
                        {t('INVITATION.DELETE_INVITATION.TEXT')}
                    </p>
                </DialogBody>
                <DialogFooter>
                    <Button type="button" loading={deleteInvitation.isPending} onClick={confirm}>
                        {t('YES')}
                    </Button>
                    <Button type="button" variant="secondary" onClick={onClose} disabled={deleteInvitation.isPending}>
                        {t('NO')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export { DeleteInvitationDialog };
